import styled from "styled-components";

export const Setup = styled.div`
  font-size: 5vw;
`;

export const Month = styled.div`
  font-size: 3.5vw;
  width: 100%;
  font-weight: 600;
  padding: 0 1rem;
  ${({ theme: { colors } }) => `
    color: ${colors("background")};
    background: ${colors("link")};
  `}
`;

export const Day = styled.div`
  font-size: 13vw;
  font-weight: 600;
`;

export const Name = styled.div`
  font-size: 2vw;
  font-style: oblique;
  padding: 0 1rem;
  width: 100%;
  ${({ theme: { colors } }) => `
    color: ${colors("link")};
  `}
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  align-content: stretch;
  max-height: 50vh;
  width: 100%;
  height: 100%;
`;
